import { jsxs as e, jsx as t, Fragment as o } from "react/jsx-runtime";

import { useRef as r, useState as n } from "react";

import i from "../Modal/index.js";

import a from "../Tooltip/index.js";

import l from "../../utils/classNames/index.js";

const s = new WeakMap, m = new ResizeObserver((e => {
    for (const t of e) {
        const e = t.target;
        s.get(e)(e.scrollHeight > e.offsetHeight);
    }
})), c = ({maxLines: c = 4, lineHeight: d = 1, modalLabel: h = "Read more", children: p, className: u, style: f, variant: g = "modal", ...x}) => {
    const b = r(null), [v, w] = n(!1);
    return e("div", {
        ...x,
        style: {
            ...f,
            maxHeight: c * d
        },
        className: l("relative overflow-hidden", u),
        ref: e => {
            e && (s.set(e, w), m.observe(e));
        },
        children: [ p, v ? "tooltip" === g ? t("div", {
            className: "pl-xl pr-xxs pointer-events-none absolute bottom-0 right-0 bg-gradient-to-r from-transparent via-white to-white",
            children: t(a, {
                content: p,
                placement: "bottom-start",
                children: t("button", {
                    type: "button",
                    className: "focus-outline-thick-light text-primary pointer-events-auto font-medium leading-none",
                    children: "Read More"
                })
            })
        }) : e(o, {
            children: [ t(i, {
                ref: b,
                label: h,
                children: p
            }), t("div", {
                className: "pl-xl pr-xxs pointer-events-none absolute bottom-0 right-0 bg-gradient-to-r from-transparent via-white to-white",
                children: t("button", {
                    className: "focus-outline-thick-light text-primary pointer-events-auto font-medium leading-none",
                    onClick: () => b.current?.open(),
                    children: "Read More"
                })
            }) ]
        }) : null ]
    });
};

export { c as default };
//# sourceMappingURL=index.js.map
